/* Livset Pazar — ürün sayfası: galeri, tam ekran görüntüleyici, varyant görseli */
(() => {
  if (customElements.get('product-gallery')) return;
  const L = window.Livset || {};

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = [...this.track.children];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.counter = this.querySelector('[data-current]');
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.thumb))));
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.track.addEventListener('scroll', (L.debounce || ((f) => f))(() => this.sync(), 50), { passive: true });
      this.index = 0;

      // Görünmeyen slaytlar (data-src) ilk görselle yarışmasın: etkileşimde hemen,
      // aksi halde sayfa yüklenip tarayıcı boşa çıkınca yüklenir.
      this.loadRest = () => {
        if (this.restLoaded) return;
        this.restLoaded = true;
        this.track.querySelectorAll('img[data-src]').forEach((img) => {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      };
      ['pointerdown', 'touchstart', 'focusin'].forEach((ev) => this.addEventListener(ev, this.loadRest, { once: true, passive: true }));
      this.track.addEventListener('scroll', this.loadRest, { once: true, passive: true });
      const whenIdle = () => ('requestIdleCallback' in window ? requestIdleCallback(this.loadRest, { timeout: 4000 }) : setTimeout(this.loadRest, 2500));
      if (document.readyState === 'complete') whenIdle();
      else window.addEventListener('load', whenIdle, { once: true });

      this.lightbox = this.querySelector('[data-lightbox]');
      this.addEventListener('click', (e) => {
        const z = e.target.closest('[data-zoom]');
        if (z) this.openLightbox(Number(z.dataset.zoom));
      });
      if (this.lightbox) {
        const lt = this.lightbox.querySelector('[data-lightbox-track]');
        this.lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => this.lightbox.close());
        this.lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', () => lt.scrollBy({ left: -lt.clientWidth, behavior: 'smooth' }));
        this.lightbox.querySelector('[data-lightbox-next]').addEventListener('click', () => lt.scrollBy({ left: lt.clientWidth, behavior: 'smooth' }));
        this.lightbox.addEventListener('click', (e) => e.target === this.lightbox && this.lightbox.close());
        this.lightbox.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') lt.scrollBy({ left: lt.clientWidth, behavior: 'smooth' });
          if (e.key === 'ArrowLeft') lt.scrollBy({ left: -lt.clientWidth, behavior: 'smooth' });
        });
        this.lightbox.addEventListener('close', () => document.body.classList.remove('is-locked'));
      }

      // Varyantın kendi görseli varsa ona kaydır
      document.addEventListener('variant:change', (e) => {
        const v = e.detail && e.detail.variant;
        if (!v || !v.featured_media) return;
        const slide = this.slides.find((s) => s.dataset.mediaId === String(v.featured_media.id));
        if (slide) this.go(Number(slide.dataset.index));
      });
    }

    go(i) {
      const n = this.slides.length;
      if (!n) return;
      const idx = (i + n) % n;
      this.loadRest();
      this.track.scrollTo({ left: this.slides[idx].offsetLeft, behavior: 'smooth' });
      this.setActive(idx);
    }

    sync() {
      const w = this.track.clientWidth;
      if (!w) return;
      this.setActive(Math.round(this.track.scrollLeft / w));
    }

    setActive(idx) {
      this.index = idx;
      this.thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === idx);
        if (n === idx) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      if (this.counter) this.counter.textContent = idx + 1;
    }

    openLightbox(i) {
      if (!this.lightbox || !this.lightbox.showModal) return;
      this.lightbox.showModal();
      document.body.classList.add('is-locked');
      const lt = this.lightbox.querySelector('[data-lightbox-track]');
      const slide = lt.querySelector(`[data-index="${i}"]`);
      requestAnimationFrame(() => {
        lt.scrollTo({ left: slide ? slide.offsetLeft : 0, behavior: 'instant' });
      });
    }
  }
  customElements.define('product-gallery', ProductGallery);
})();
